import React from "react";
import { IDoctor } from "../../../../dto/interfaces";
import { Button } from "../../../../components/common/button";
import { assets } from "../../../../assets/assets";

interface DoctorProfileParams {
    doctor: IDoctor;
}

const HeroSection: React.FC<DoctorProfileParams> = ({ doctor }) => {
    const onBookAppointment = () => {
        // Find the booking section element by its ID
        const bookingSection = document.getElementById("book-appointment");

        if (bookingSection) {
            // Use the browser's built-in smooth scroll
            bookingSection.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            // Fallback if the element isn't found
            console.warn("Booking section with id 'book-appointment' not found.");
        }
    };
    return (
        <section id="hero" className="relative w-full overflow-hidden py-6">
            <div className="container mx-auto px-6">
                <div className="relative bg-blue-100 rounded-[32px] md:rounded-[64px] overflow-hidden flex flex-col-reverse md:flex-row items-center justify-between p-8 md:p-12 lg:p-16 gap-8">
                    {/* Text Content */}
                    <div className="relative z-10 flex-1 text-center md:text-left md:pr-12 lg:pr-20 mb-6 md:mb-0 font-inter">
                        <p className="text-base md:text-xl font-semibold text-blue-700 uppercase tracking-wide md:mb-2">
                            Dr. {doctor.name}
                        </p>
                        <h1 className="text-4xl md:text-5xl lg:text-6xl tracking-normal md:max-w-[70%] font-bold text-[#091E42] leading-tight md:mb-6">
                            {doctor?.tagline || "Your health, our priority"}
                        </h1>
                        <p className="text-sm md:text-xl text-[#001B4ACC] max-w-lg mx-auto md:mx-0 mb-4 md:mb-6">
                            {doctor?.subheading || "Expert care focused on your health and wellbeing."}
                        </p>

                        {/* Book Appointment Button */}
                        <Button onClick={onBookAppointment} size="md">
                            Book Appointment
                        </Button>
                    </div>

                    {/* Doctor Image */}
                    <div className="relative z-0 flex-none w-full md:w-auto h-auto md:h-full flex justify-center md:justify-end">
                        <img
                            src={doctor.profileImage || assets?.placeholder_avatar_image} // Fallback path
                            alt={`Dr. ${doctor.name || "Doctor Image"}`}
                            className="w-full md:w-[350px] lg:w-[400px] h-auto object-cover rounded-2xl md:rounded-tr-[64px] md:rounded-br-[64px]"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
